var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"size":_vm.size,"clearable":""},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.caption,"value":item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }